// extracted by mini-css-extract-plugin
module.exports = {"table-actions":"sync-events-table_table-actions__CUgr3","pagination":"sync-events-table_pagination__Kvllt","filter-select":"sync-events-table_filter-select__P3GGH"};